/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Video_Lock_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Video Lock" |
*
* @param {Player_Video_Lock_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_video_lock_aria_label = /** @type {((inputs?: Player_Video_Lock_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Video_Lock_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouillage de la Video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videosperre")
	if (locale === "it") return /** @type {LocalizedString} */ ("Blocco video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеоблокировка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueo de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频锁")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオロック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो लॉक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Bloqueio de vídeo")
	return /** @type {LocalizedString} */ ("Video Lock")
});